import { render, staticRenderFns } from "./DashIntakeInvestigations.vue?vue&type=template&id=6201dfaf&scoped=true&"
import script from "./DashIntakeInvestigations.vue?vue&type=script&lang=js&"
export * from "./DashIntakeInvestigations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201dfaf",
  null
  
)

export default component.exports